module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAcklEQVQ4ja3TwQ2AIBBE0cHY11IadDZUpieNIbjsiHMjJO/wk00kDwRnZmit3W+SKKVgU4Ba6/AvhHhACHkCOWcd6QEz05ARIDVRgCHiAaEmM2DaJAK4TVYAANgU4K1JUm6nn3w73n5BdpLLSALwucm1E4OwUFkPaBMWAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/GRIP.png
// module id = 61
// module chunks = 0